import React from 'react';
import swal from 'sweetalert';
import swal2 from 'sweetalert2';
import shortid from 'shortid';
import { Link } from 'react-router-dom';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';
import { findField } from '../actions/common';
import { sfRequest } from '../../../utils/common';
import { fetchQueryData } from '../../../utils/sf-request';

export async function getAllFundRequest(partnerId, siteToken) {
    return fetch(`${spmfcloudFunctionUrl}/fund-request`, {
        mode: 'cors',
        cache: 'force-cache',
        method: 'GET',
        headers: {
            'hash-token': siteToken,
            'Content-Type': 'application/json',
        },
    }).then(response => response.json());
}

export async function getAllFundRequestsDisbursment(partnerId, siteToken) {
    
    return fetch(`${spmfcloudFunctionUrl}/fund-request/disbursment`, {
        mode: 'cors',
        cache: 'force-cache',
        method: 'GET',
        headers: {
            'hash-token': siteToken,
            'Content-Type': 'application/json',
        },
    }).then(response => response.json());
}

export default null;

export function fundRequestColumn() {
    const isApprover = this.props.user.loggedInUser.Partner_Authority__c === 'Approver';
    const partnerType = this.props.user.loggedInUser.Account.Partner_Type__c === 'School';

    return [{
        Header: 'Fund No',
        accessor: 'Name',
        Cell: propsColumn => <Link to={`/portal/fund-request/${propsColumn.row.Id}`}>{propsColumn.value}</Link>,
        filterable: true,
    }, {
        Header: 'Year',
        accessor: 'Year__c',
        filterMethod: (filter, row) => {
            const pattern = new RegExp(filter.value);
            if (pattern.test(`${row.Year__c}`)) return row;
        },
    }, {
        accessor: 'Period__c', // Required because our accessor is not a string
        Header: 'Period',
        filterable: true,
    }, {
        Header: 'Req Amount (Pri/Sec)',
        accessor: 'Request_Amount_Pri_SecF__c',
        Cell: propsCol => <p style={{ textAlign: 'right' }}>$ {propsCol.value ? propsCol.value.toFixed(2) : 0}</p>,
        filterMethod: (filter, row) => {
            const pattern = new RegExp(filter.value);
            if (pattern.test(`${row.Request_Amount_Pri_SecF__c}`)) return row;
        },
    }, {
        Header: 'Req Amount (Post/Sec)',
        accessor: 'Request_Amount_Post_Sec__c',
        Cell: propsCol => <p style={{ textAlign: 'right' }}>$ {propsCol.value ? propsCol.value.toFixed(2) : 0}</p>,
        filterMethod: (filter, row) => {
            const pattern = new RegExp(filter.value);
            if (pattern.test(`${row.Request_Amount_Post_Sec__c}`)) return row;
        },
    }, {
        Header: 'FR Status',
        accessor: 'FR_Status__c',
        filterable: true,
        Filter: ({ filter, onChange }) => {
            const fieldInfo = findField('FR_Status__c', this.props.objectInfoFR);
            return (
                <select
                    onChange={event => onChange(event.target.value)}
                    className="form-control"
                    value={filter ? filter.value : ''}
                >
                    <option value="">All</option>
                    {Object.keys(fieldInfo).length > 0 ? fieldInfo.picklistValues.map(optionValue => (
                        <option key={shortid.generate()} value={optionValue.value}>{optionValue.label}</option>
                    )) : null}
                </select>
            );
        },
    }, {
        Header: 'Dis.Amount (Pri)',
        accessor: 'disbursment.Disbursed_Amount_Pri__c',
        Cell: propsCol => <p style={{ textAlign: 'right' }}>$ {propsCol.value ? propsCol.value.toFixed(2) : 0}</p>,
        filterMethod: (filter, row) => {
            const pattern = new RegExp(filter.value);
            if (pattern.test(`${row['disbursment.Disbursed_Amount_Pri__c']}`)) return row;
        },
    }, {
        Header: 'Dis.Amount (Sec)',
        accessor: 'disbursment.Disbursed_Amount_Sec__c',
        Cell: propsCol => <p style={{ textAlign: 'right' }}>$ {propsCol.value ? propsCol.value.toFixed(2) : 0}</p>,
        filterMethod: (filter, row) => {
            const pattern = new RegExp(filter.value);
            if (pattern.test(`${row['disbursment.Disbursed_Amount_Sec__c']}`)) return row;
        },
    }, {
        Header: 'Dis.Amount (Post-Sec)',
        accessor: 'disbursment.Disbursed_Amount_Post_Sec__c',
        Cell: propsCol => <p style={{ textAlign: 'right' }}>$ {propsCol.value ? propsCol.value.toFixed(2) : 0}</p>,
        filterMethod: (filter, row) => {
            const pattern = new RegExp(filter.value);
            if (pattern.test(`${row['disbursment.Disbursed_Amount_Post_Sec__c']}`)) return row;
        },
    }, {
        Header: 'Actions',
        accessor: 'Id',
        minWidth: 200,
        Cell: (columnProps) => {
            let buttons = [];
            // given different keys to button
            if (columnProps.row.FR_Status__c === 'Planned') {
                if (partnerType === 'Disbursing Agency') {
                    buttons[0] = (
                        <button
                            className="btn btn-success btn-sm"
                            key="Edit"
                            onClick={() => this.setState({ modalShownFR: true, selectedId: columnProps.value })}
                        >
                            <i className="fa fa-pencil" /> Edit
                        </button>
                    );
                }
                if (isApprover === false) {
                    // buttons.push(
                    //     <button className="btn btn-success btn-sm" key="Verify" onClick={() => this.updateFRStatus(columnProps.value, 'Verified by Partner')}>
                    //         <i className="fa fa-check" /> Verify
                    //     </button>,
                    // );
                }
            } else if (columnProps.row.FR_Status__c === 'Verified by Partner' && isApprover) {
                // buttons.push(
                //     <button className="btn btn-success btn-fill btn-sm" key="Approve" onClick={() => this.updateFRStatus(columnProps.value, 'Approved_by_Partner')}>
                //         <i className="fa fa-thumbs-up" /> Approve
                //     </button>,
                //     <button className="btn btn-danger btn-fill btn-sm" key="Reject" onClick={() => this.updateFRStatus(columnProps.value, 'Rejected by Partner')}>
                //         <i className="fa fa-thumbs-down" /> Reject
                //     </button>,
                // );
            } else if (columnProps.row.FR_Status__c === 'Rejected_by_SPMF' || columnProps.row.FR_Status__c === 'Rejected by SPMF') {
                buttons.push(
                    <button
                        className="btn btn-info btn-default btn-sm"
                        key="Revert"
                        onClick={() => this.updateFRStatus(columnProps.value, 'Planned')}
                    >
                        <i className="fa fa-refresh" /> Revert
                    </button>,
                );
            } else if (columnProps.row.FR_Status__c === 'Approved by SPMF') {
                buttons.push(
                    <button className="btn btn-default btn-sm" key="disbursed" onClick={() => this.setState({ modalShown: true, selectedId: columnProps.value })}>
                        <i className="fa fa-edit" /> Confirm
                    </button>,
                );
            } else if (columnProps.row.FR_Status__c === 'Approved_by_Partner' && isApprover) {
                buttons = [];
                buttons.push(
                    <button className="btn btn-fill btn-warning btn-sm" key="Submit" onClick={() => this.updateFRStatus(columnProps.value, 'Submitted_Internal_Approval')}>
                        <i className="fa fa-paper-plane" /> Submit
                    </button>,
                );
            }
            return (
                <div className="btn-group" role="group" aria-label="...">
                    {buttons}
                </div>
            );
        },
    }];
}

/**
 * Update a record to salesforce, need to be bind with main component
 * @param {*} id : Termination ID
 * @param {*} status : Status that want to inserted
 */
export async function updateFRStatus(id, status) {
    if (this.state.loading) return;
    this.setState({ loading: true });
    try {
        if (status === 'Approved_by_Partner') {
            const { token } = this.props.salesforce;
            const verificationCode = Math.floor((Math.random() * 777) + (Math.random() * 4777));
            const sfRequestConfig = {
                method: 'PATCH',
                url: token.instanceUrl,
                id: this.props.user.loggedInUser.Id,
                accessToken: token.accessToken,
                bodyParams: { Verification_Code__c: verificationCode },
            };
            // Send the code first...
            await sfRequest('Contact', sfRequestConfig);

            // ...then the verification request
            sfRequestConfig.bodyParams = { Send_Verification_Code__c: true };
            await sfRequest('Contact', sfRequestConfig);

            const { value: submittedCode } = await swal2({
                title: 'Verification',
                input: 'text',
                text: 'We have sent a verification code to your email. Please enter it below.',
                showCancelButton: true,
                inputValidator: (value) => {
                    return !value && 'Please insert right verification code';
                },
            });
            if (submittedCode) {
                const { user } = this.props;
                const query = `SELECT Verification_Code__c FROM Contact WHERE Id = '${this.props.user.loggedInUser.Id}'`;
                const result = await fetchQueryData(query, user.siteToken.hash, user.key);
                if (result.records[0].Verification_Code__c !== submittedCode) {
                    throw new Error('Invalid verification code');
                }
            } else {
                this.setState({ loading: false });
                return;
            }
        }

        const result = await fetch(`${spmfcloudFunctionUrl}/sobject/Fund_Request__c`, {
            mode: 'cors',
            cache: 'no-cache',
            method: 'PATCH',
            body: JSON.stringify({
                Id: id,
                FR_Status__c: status,
            }),
            headers: {
                'hash-token': this.props.user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(async (response) => {
            const json = await response.json();
            if (!response.ok) throw new Error(json.message);
            return json;
        });
        const fundRequestList = await this.componentWillMount(true);
        swal({
            text: result.message,
            title: 'Fund Request status updated successfully.',
        });
        this.setState({ loading: false, fundRequestList });
    } catch (error) {
        swal({
            text: error.message,
            title: 'An error occured when updating status',
        });
        this.setState({ loading: false });
    }
}

/**
 * View all field in Fund Request
 */

export async function getFundRequest(id = 'describe') {
    if (this.state.loading) return;
    this.setState({ loading: true });
    try {
        const result = await fetch(`${spmfcloudFunctionUrl}/sobject/Fund_Request__c/${id}`, {
            mode: 'cors',
            cache: 'no-cache',
            method: 'GET',
            headers: {
                'hash-token': this.props.user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then((response) => {
            if (response.status !== 200) throw (new Error(response.message));
            return response.json();
        });
        if (id !== 'describe') this.setState({ loading: false, fundRequest: result.result });
        else this.setState({ loading: false, layout: result.result });
    } catch (error) {
        swal({
            text: error.toString(),
            title: 'An error occured when getting Fund Request',
        });
        this.setState({ loading: false });
    }
}


// Get single the disbursed item by specifying the record Id
export async function getDisbursedItem(id) {
    if (this.state.loading) return;
    const { user } = this.props;
    this.setState({ loading: true });
    try {
        const query = `Select Id, Name, Disbursed_Amount_Pri__c, Disbursed_Amount_Sec__c, Disbursed_Amount_Post_Sec__c from Disbursement_Item__c where
                Fund_Request__c = '${id}' and Status__c in ('Approved', 'Disbursed')`;
        const result = await fetchQueryData(query, user.siteToken.hash, user.key);
        if (result.records) {
            if (result.records.length > 0) this.setState({ form: result.records[0] || {}, loading: false });
            else if (typeof this.props.hideModal === 'function') {
                this.props.hideModal();
                this.setState({ loading: false });
            }
        }
    } catch (error) {
        swal({
            text: error.toString(),
            title: 'An error occured when getting Fund Requst',
        });
        this.setState({ loading: false });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/FundRequest/actions.js
// module id = 148
// module chunks = 0